import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import '../styles/page-layout.css';

const ForbiddenPage: React.FC = () => {
  return (
    <Layout
      title="Zugriff verweigert | StimmDigital"
      description="Du hast keine Berechtigung, auf diese Seite zuzugreifen."
      keywords="403, Zugriff verweigert, Berechtigung"
    >
      <section className="wrapper">
        <div className="page-container" style={{ textAlign: 'center', padding: '4rem 2rem' }}>
          <div style={{ maxWidth: '600px', margin: '0 auto' }}>
            <h1 style={{ 
              fontSize: '6rem', 
              fontWeight: '800', 
              background: 'linear-gradient(135deg, #77F76C, #77F76C)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              marginBottom: '1rem'
            }}>
              403
            </h1>
            
            <h2 style={{ 
              fontSize: '2rem', 
              marginBottom: '1rem',
              color: 'var(--text-color)'
            }}>
              Zugriff verweigert
            </h2>
            
            <p style={{ 
              fontSize: '1.1rem', 
              color: 'var(--text-muted)',
              marginBottom: '3rem',
              lineHeight: '1.6'
            }}>
              Du hast keine Berechtigung, auf diese Seite zuzugreifen. 
              Falls du glaubst, dass dies ein Fehler ist, kontaktiere uns bitte.
            </p>

            <div style={{ 
              display: 'flex', 
              gap: '1rem', 
              justifyContent: 'center',
              flexWrap: 'wrap',
              marginBottom: '3rem'
            }}>
              <Link 
                to="/" 
                className="primary-button"
                style={{ textDecoration: 'none' }}
              >
                <i className="fas fa-home" style={{ marginRight: '0.5rem' }}></i>
                Zur Startseite
              </Link>
              
              <Link 
                to="/beratungstermin" 
                className="secondary-button"
                style={{ textDecoration: 'none' }}
              >
                <i className="fas fa-user-shield" style={{ marginRight: '0.5rem' }}></i>
                Berechtigungen anfragen
              </Link>
            </div>

            <div style={{ 
              padding: '2rem',
              background: 'var(--card-background)',
              borderRadius: '1rem',
              border: '1px solid var(--border-color)',
              textAlign: 'left'
            }}>
              <h3 style={{ marginBottom: '1rem', color: 'var(--text-color)' }}>
                Mögliche Gründe:
              </h3>
              
              <ul style={{ 
                color: 'var(--text-muted)',
                lineHeight: '1.8',
                paddingLeft: '1.5rem',
                marginBottom: '2rem'
              }}>
                <li>Du bist nicht angemeldet oder deine Sitzung ist abgelaufen</li>
                <li>Dein Benutzerkonto hat keine ausreichenden Berechtigungen</li>
                <li>Der Zugriff auf diesen Bereich ist eingeschränkt</li>
                <li>Die angeforderte Ressource ist nur für bestimmte Nutzer verfügbar</li>
              </ul>

              <div style={{ 
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '1rem'
              }}>
                <a 
                  href="mailto:support@stimm.digital?subject=Zugriff%20verweigert%20-%20Berechtigung%20benötigt"
                  style={{ 
                    color: 'var(--primary-color)',
                    textDecoration: 'none',
                    padding: '1rem',
                    borderRadius: '0.5rem',
                    border: '1px solid var(--border-color)',
                    transition: 'background-color 0.3s ease',
                    display: 'block'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = 'var(--primary-color-light)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                >
                  <i className="fas fa-envelope" style={{ marginRight: '0.5rem' }}></i>
                  <strong>E-Mail Support</strong>
                  <br />
                  <small style={{ color: 'var(--text-muted)' }}>
                    Beschreibe dein Anliegen
                  </small>
                </a>
                
                <a 
                  href="tel:+493012345678"
                  style={{ 
                    color: 'var(--primary-color)',
                    textDecoration: 'none',
                    padding: '1rem',
                    borderRadius: '0.5rem',
                    border: '1px solid var(--border-color)',
                    transition: 'background-color 0.3s ease',
                    display: 'block'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = 'var(--primary-color-light)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                >
                  <i className="fas fa-phone" style={{ marginRight: '0.5rem' }}></i>
                  <strong>Direkt anrufen</strong>
                  <br />
                  <small style={{ color: 'var(--text-muted)' }}>
                    Schnelle Hilfe am Telefon
                  </small>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default ForbiddenPage;
